/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
import { Screen, Text } from "components"
import React, { useCallback, useEffect, useState } from "react"
import {
  Dimensions,
  FlatList,
  Image,
  Platform,
  StatusBar,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import Carousel from "react-native-reanimated-carousel"
import { useSharedValue } from "react-native-reanimated"
import { colors } from "colors"
import { bronzeCircle } from "./helper/logo"
import { map, size } from "lodash"
import LinearGradient from "react-native-linear-gradient"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import flash from "config/flash"
import { getFCMToken } from "utils/firebase"
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context"
import { Ionicons } from "@expo/vector-icons"
import EmptyState from "components/EmptyState"
import { observer } from "mobx-react-lite"
import { useColor } from "app/theme/getThemes"
import AsyncStorage from "@react-native-async-storage/async-storage"
import moment from "moment"
import StampItems from "components/StampItems"
import TierCard from "components/TierCard"
import ReferralCodeCard from "components/ReferralCodeCard/ReferralCodeCard"

export const HomeScreen = observer(() => {
  const { companyTheme } = useColor()
  const { height } = useWindowDimensions()

  const { sessionExpired } = useSessionExpired()
  const { userStore, couponStore } = useStores()
  const navigation = useNavigation<any>()
  const route = useRoute()
  const { routeFrom }: any = route?.params || {}

  const [isModalVisible, setIsModalVisible] = useState<boolean | null>(null)
  const progressValue = useSharedValue<number>(0)
  const [point, setPoint] = useState(userStore?.totalPoint)
  const voucherIcon = require("assets/voucherRedeemed.png")
  const [showInstallPrompt, setShowInstallPrompt] = useState(false)
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null)
  const [banner, setBanner] = useState([])
  const [voucher, setVoucher] = useState([])
  const [promotionList, setPromotionList] = useState([])
  const [reward, setRewards] = useState([])

  const [stamps, setStamps] = useState<any>([])

  const onCloseModal = () => {
    setIsModalVisible(false)
  }

  const getInitialModalState = async () => {
    if (Platform.OS === "web") {
      return localStorage.getItem("pop_up") !== "false"
    } else {
      const storedValue = await AsyncStorage.getItem("pop_up")
      return storedValue !== "false"
    }
  }

  useEffect(() => {
    getInitialModalState().then(setIsModalVisible)
  }, [])

  const onDisableModal = async () => {
    if (Platform.OS === "web") {
      localStorage.setItem("pop_up", "false")
    } else {
      await AsyncStorage.setItem("pop_up", "false")
    }
    setIsModalVisible(false)
  }

  // const getResponsiveWidth = useResponsiveWidth()
  // const { width } = getResponsiveWidth()
  const { width } = useWindowDimensions()

  useEffect(() => {
    navigation.setOptions({
      headerTitle: "",
      headerShown: false,
    })
  })

  useEffect(() => {
    getFCMToken(userStore?.accessToken, userStore?.id)
  }, [])

  useEffect(() => {
    // Handle PWA install prompt
    if (Platform.OS === "web") {
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault()
        setDeferredPrompt(e)
        setShowInstallPrompt(true)
      })
    }
  }, [])

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt()
      const { outcome } = await deferredPrompt.userChoice
      if (outcome === "accepted") {
        setDeferredPrompt(null)
        setShowInstallPrompt(false)
        console.log("User accepted the install prompt")
      } else {
        setDeferredPrompt(null)
        setShowInstallPrompt(false)
        console.log("User dismissed the install prompt")
      }
      setDeferredPrompt(null)
      setShowInstallPrompt(false)
    }
  }

  const onCloseInstallPrompt = () => {
    setShowInstallPrompt(false)
  }

  useFocusEffect(
    useCallback(() => {
      getCoupon()
      getUserPoint()
      getBanner()
      getVoucher()
      getPromotion()
      getStamp()
      getTierByUserId()
      getNotification()
      return () => setPoint(0)
    }, []),
  )

  const getCoupon = async () => {
    try {
      const res = await fetch(`${process.env.API_URL}/api/voucher/coupon/${userStore?.id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
      })

      if (res.ok) {
        const response = await res.json();
        const coupons = Array.isArray(response) ? response : [response];

        const firstVoucherForToday = coupons.find(coupon =>
          moment(coupon.start_date).isSame(moment(), 'day')
        );

        if (firstVoucherForToday) {
          const areIdsDifferent = firstVoucherForToday.voucher_catalog_id !== couponStore.newCouponNotifiedId;

          if (areIdsDifferent) {
            couponStore.setShowBadge(true);
            couponStore.setNewCouponNotifiedId(firstVoucherForToday.voucher_catalog_id);
          }
        }
      } else {
        console.log("Failed to call api");
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getUserPoint = async () => {
    await fetch(`${process.env.API_URL}/api/client/pointbal`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setPoint(responseData?.data)
          // setPoint(9000)
          userStore?.update({
            totalPoint: responseData?.data,
            // totalPoint: 9000,
          })
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getPromotion = async () => {
    await fetch(`${process.env.API_URL}/api/promotion/ongoing`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          //DISPLAY 3
          const filterData = responseData?.filter((a: any) => a.status !== "inactive")?.slice(0, 3)

          //DISPLAY ALL
          //const filterData = responseData?.filter((a: any) => a.status !== "inactive")

          setPromotionList(filterData)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreivePromotion"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreivePromotion"))
        console.error(e)
      })
  }

  const getBanner = async () => {
    await fetch(`${process.env.API_URL}/api/banner/ongoing`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          const newData = responseData?.filter((a) => a.status === "active")

          const images = map(newData, (e) => {
            return e?.banner_image
          })

          setBanner(images)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getVoucher = async () => {
    const typesArray = ["cash", "active_promotion", "passive_promotion"]
    await fetch(`${process.env.API_URL}/api/voucher?types=${typesArray}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setVoucher(responseData.filter((a) => a?.status === "active"))
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveVoucher"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreiveVoucher"))
        console.error(e)
      })
  }

  const [tierLevel, setTierLevel] = useState<any>([
    { currentTier: "", point: 0, nextPoint: 0, icon: null, expiry: null },
  ])
  const [tierLoading, setTierLoading] = useState(true)

  const getTierByUserId = async () => {
    try {
      // Fetch the member's tier data
      const userTierResponse = await fetch(
        `${process.env.API_URL}/api/tier/member/${userStore.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userStore?.accessToken}`,
          },
        },
      )

      if (!userTierResponse.ok) {
        const errorMsg = await userTierResponse.json()
        if (["Token expired", "Invalid token"].includes(errorMsg?.error)) {
          sessionExpired()
        }
        return // Exit early on error
      }

      const userTierData = await userTierResponse.json()

      const memberTier = userTierData?.get_member_tier_info?.[0]

      if (!memberTier) return // Exit if no tier data is found

      const currentTierId = userTierData?.current_tier

      // Fetch the current tier details
      const currentTierResponse = await fetch(`${process.env.API_URL}/api/tier/${currentTierId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userStore?.accessToken}`,
        },
      })

      if (!currentTierResponse.ok) {
        const errorMsg = await currentTierResponse.json()
        if (["Token expired", "Invalid token"].includes(errorMsg?.error)) {
          sessionExpired()
        }
        return // Exit early on error
      }

      const currentTierData = await currentTierResponse.json()
      // console.log("memberTier ==>", memberTier)
      // console.log("Current Tier Data ===>", currentTierData)

      const currentTierInfo = currentTierData?.[0]
      if (!currentTierInfo) return // Exit if no tier data is found

      // Combine both data sets into one state update
      setTierLevel([
        {
          point: memberTier?.sum_sales,
          nextPoint: memberTier?.next_tier_amt ?? "MAX", // Using nullish coalescing for "MAX"
          nextTier: memberTier?.next_tier_name, // Using nullish coalescing for "MAX"
          currentTier: currentTierInfo.tier_name?.toLowerCase(),
          icon: currentTierInfo.tier_image,
          expiry: userTierData.membership_expiry_date,
          allData: memberTier,
        },
      ])

      setTierLoading(false)
    } catch (error) {
      console.error("Error fetching tier data:", error)
    }
  }

  const tierColor = {
    gold: ["#FFF5B7", "#FFD700", "#FFB14E", "#D99200"],
    silver: ["#E0E0E0", "#C0C0C0", "#A9A9A9", "#D4D4D4"],
    bronze: ["#E3B778", "#CD7F32", "#D8A162", "#A76B29"],
  }

  const currentTier = tierLevel[0]?.currentTier || "white"
  const tierColors = tierColor[currentTier] || [companyTheme.first, companyTheme.second]

  const progress =
    // tierLevel[0]?.point === 0
    //   ? 0
    //   : 100 / (tierLevel[0]?.nextPoint === "MAX" ? tierLevel[0]?.point : tierLevel[0]?.nextPoint)
    (tierLevel[0]?.point === 0 ? 0 : tierLevel[0]?.point) /
      (tierLevel[0]?.nextPoint === "MAX"
        ? tierLevel[0]?.point === 0
          ? 100
          : tierLevel[0]?.point
        : tierLevel[0]?.nextPoint) || 0

  // console.log("progress =>", progress)

  const screenWidth = Dimensions.get("screen").width
  const maxBannerWidth = 800 // Maximum width for the banner
  const bannerWidth = Math.min(screenWidth, maxBannerWidth) // Choose the smaller value between screenWidth and maxWidth
  const bannerHeight = (bannerWidth * 9) / 16 // Maintain 16:9 aspect ratio

  const getStamp = async () => {
    await fetch(`${process.env.API_URL}/api/stamps/member/${userStore.id}/ongoing`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          setStamps(responseData)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreivePromotion"))
        console.error(e)
      })
  }

  const [notification, setNotification] = useState<any>([])

  const getNotification = async () => {
    await fetch(`${process.env.API_URL}/api/notification/member/${userStore?.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          console.log(
            "This is notification ==>",
            responseData?.filter((a) => a.has_read === false),
          )

          setNotification(responseData?.filter((a) => a.has_read === false))
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
  return (
    <Screen preset="scroll" contentContainerStyle={{ paddingBottom: 30 }}>
      {/* Start Of Complicated Structure Header */}
      <View
        style={{
          width,
          backgroundColor: "transparent",
          position: "relative",
          height: 130,
          maxWidth: 800,
          zIndex: 999,
          marginTop: StatusBar.currentHeight,
        }}
      >
        <View style={style.headerBottomRightCurveContainer}>
          <LinearGradient
            style={style.headerBottomContainer}
            colors={[companyTheme.first, companyTheme.second]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <View style={{ flexDirection: "row" }}>
                <View style={style.headerLeftContainer}>
                  <View style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <TouchableOpacity
                      onPress={() => navigation.navigate("profileStack", { screen: "profile" })}
                      style={style.headerLeft}
                    >
                      {userStore?.profileImage ? (
                        <Image
                          source={{ uri: userStore?.profileImage }}
                          style={style.profileImage}
                          resizeMode="cover"
                        />
                      ) : (
                        <>
                          <Image source={bronzeCircle} style={style.headerTierLogo} />
                          <Text style={style.headerSingleUsername}>
                            {userStore?.fullName?.charAt(0)}
                          </Text>
                        </>
                      )}
                    </TouchableOpacity>
                    <Text
                      style={[
                        style.headerHiText,
                        {
                          fontWeight: "bold",
                        },
                      ]}
                      numberOfLines={2}
                      ellipsizeMode="tail"
                    >
                      {userStore?.fullName || ""}
                    </Text>
                  </View>
                </View>
              </View>

              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "30%",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <TouchableOpacity
                  style={style.QRbuttonContainer}
                  onPress={() => navigation.navigate("memberQr")}
                >
                  <Ionicons name="qr-code-sharp" size={30} color="white" />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => navigation.navigate("notification")}>
                  {notification && notification.length > 0 ? (
                    <View
                      style={{
                        width: 10,
                        height: 10,
                        position: "absolute",
                        right: 0,
                        borderRadius: 100,
                        backgroundColor: "red",
                      }}
                    />
                  ) : null}
                  <Ionicons name="notifications" size={30} color="white" />
                </TouchableOpacity>
              </View>
            </View>
            <TouchableOpacity
              style={style.pointContainer}
              onPress={() => navigation.navigate("pointHistory")}
            >
              <Text style={style.text}>{translate("redeemScreen.availablePoint")} : </Text>
              <Text style={style.text}>
                {point?.toLocaleString() || 0} {translate("redeemScreen.point")}
              </Text>
            </TouchableOpacity>
          </LinearGradient>
        </View>
      </View>

      {/* End Of Complicated Structure Header */}

      <SafeAreaProvider>
        <SafeAreaView style={[style.container, { maxHeight: height, flex: 1 }]}>
          {/* Banner */}
          {banner && banner.length > 0 ? (
            <View style={{ marginBottom: 10, paddingTop: 10, width: 800, top: -10 }}>
              <Carousel
                loop
                width={bannerWidth}
                height={bannerHeight}
                autoPlay={true}
                data={banner}
                scrollAnimationDuration={5000}
                style={{
                  width: bannerWidth,
                  height: bannerHeight,
                  maxHeight: bannerHeight,
                  minWidth: bannerWidth,
                  backgroundColor: companyTheme.first,
                }}
                modeConfig={{
                  parallaxScrollingScale: Platform.OS === "web" ? 0.89 : 2,
                  parallaxScrollingOffset: 50,
                }}
                onProgressChange={(_, absoluteProgress) => (progressValue.value = absoluteProgress)}
                renderItem={(item: any) => {
                  const imageSource =
                    Platform.OS === "web" && item?.item !== null ? item?.item : { uri: item?.item }
                  return (
                    <View
                      style={[
                        style.carouselContainer,
                        { height: bannerHeight, width: bannerWidth },
                      ]}
                    >
                      {Platform.OS === "web" ? (
                        <img src={imageSource} style={style.carouselImage} />
                      ) : (
                        <Image source={imageSource} style={style.carouselImage} />
                      )}
                    </View>
                  )
                }}
              />
            </View>
          ) : (
            <View
              style={{
                height: bannerHeight,
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: colors.lighterGrey,
              }}
            >
              <Text style={{ fontSize: 16, color: "#888" }}>No banner available</Text>
            </View>
          )}

          {/* Tier */}
          <View style={{ paddingHorizontal: "2%" }}>
            <View style={[style.tierContainer, { marginBottom: 5 }]}>
              <Text>Your Current Tier</Text>
              <TouchableOpacity onPress={() => navigation.navigate("member")}>
                <Text style={[style.showAllText, { color: companyTheme.first }]}>
                  {translate("common.showAll")}
                </Text>
              </TouchableOpacity>
            </View>
            <TierCard loading={tierLoading} tierLevel={tierLevel} home={true} />
          </View>

          {/* Referral Code */}
          {/* <View style={{ paddingHorizontal: "3%" }}>
            <View style={[style.tierContainer, { marginBottom: 5 }]}>
              <Text>Your Referral Code</Text>
            </View>
            <ReferralCodeCard referral={userStore?.referral_code} tierLevel={tierLevel} />
          </View> */}

          {/* Stamps */}
          {size(stamps) > 0 ? (
            <View style={{ paddingTop: "3%" }}>
              <View style={style.mt15}>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingHorizontal: "3%",
                  }}
                >
                  <Text>My Stamps</Text>
                  <TouchableOpacity
                    onPress={() => {
                      navigation.navigate("stamp")
                    }}
                  >
                    <Text style={[style.showAllText, { color: companyTheme.first }]}>
                      {translate("common.showAll")}
                    </Text>
                  </TouchableOpacity>
                </View>

                <View style={{ paddingHorizontal: "3%", paddingTop: 10 }}>
                  <StampItems stamps={stamps[0]} />
                </View>
              </View>
            </View>
          ) : null}

          {/* Promotion */}
          {promotionList.length > 0 && (
            <View style={{ paddingTop: "3%" }}>
              <View style={style.mt15}>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingHorizontal: "3%",
                  }}
                >
                  <Text>Latest</Text>
                  <TouchableOpacity onPress={() => navigation.navigate("promotionHome")}>
                    <Text style={[style.showAllText, { color: companyTheme.first }]}>
                      {translate("common.showAll")}
                    </Text>
                  </TouchableOpacity>
                </View>
                <FlatList
                  style={[style.mt10, { paddingLeft: "3%" }]}
                  data={promotionList}
                  horizontal
                  showsHorizontalScrollIndicator={false}
                  renderItem={({ item }) => {
                    return (
                      <TouchableOpacity
                        onPress={() => {
                          navigation.navigate(
                            "promotionDetail",
                            { promotion_id: item?.promotion_id }, // Pass params under 'params'
                          )
                        }}
                        style={[style.voucherContainer, { width: width / 2.9 }]}
                      >
                        {item?.promotion_banner && (
                          <Image
                            source={{ uri: item?.promotion_banner }}
                            resizeMode="cover"
                            style={[
                              style.voucherImage,
                              { width: width / 2.9, height: width / 2.9 },
                            ]}
                          />
                        )}

                        <View style={{ marginTop: 10 }}>
                          <Text numberOfLines={1}>{item?.promotion_name}</Text>
                        </View>
                      </TouchableOpacity>
                    )
                  }}
                  ListEmptyComponent={() => {
                    return <EmptyState />
                  }}
                />
              </View>
              <View style={{ height: 50, width: "100%" }} />
            </View>
          )}
        </SafeAreaView>
      </SafeAreaProvider>
      {/* <Modal
        isVisible={isModalVisible || false}
        onBackdropPress={onCloseModal}
        onBackButtonPress={onCloseModal}
      >
        {routeFrom === "register" ? (
          <View style={{ backgroundColor: "white", padding: 20, borderRadius: 20 }}>
            <Image
              source={voucherIcon}
              style={{
                alignSelf: "center",
                height: 200,
                position: "absolute",
                top: -120,
                width: 200,
                zIndex: 99,
              }}
            />
            <View style={{ alignItems: "center", marginTop: 60 }}>
              <Text
                style={{
                  fontFamily: typography.primary.normal,
                  fontSize: 18,
                  marginBottom: 10,
                  marginTop: 20,
                  textAlign: "center",
                }}
              >
                Sign up successfully!
              </Text>
              <Text
                style={{
                  fontFamily: typography.primary.normal,
                  marginBottom: 10,
                  textAlign: "center",
                }}
              >
                You have received an exclusive welcome reward as a token of our appreciation for
                joining us.
              </Text>
              <Button
                title={translate("voucherScreen.checkVoucher")}
                onPress={() => {
                  onCloseModal()
                  navigation.navigate("voucher")
                }}
              />
            </View>
          </View>
        ) : (
          <View
            style={{
              alignSelf: "center",
              alignItems: "center",
              width: Dimensions.get("screen").width * 0.8,
              height: Dimensions.get("screen").width * 0.8,
              maxHeight: 500,
              maxWidth: 500,
            }}
          >
            <TouchableOpacity
              onPress={() => onCloseModal()}
              style={{
                backgroundColor: "white",
                position: "absolute",
                top: 10,
                zIndex: 99,
                right: 10,
                width: 30,
                height: 30,
                borderRadius: 100,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text style={{ fontSize: 25 }}>X</Text>
            </TouchableOpacity>
            <Image
              source={{
                uri: "https://storage.googleapis.com/dekode_bucket/gama/IMAGES/promotion/1741243783_gamapromotion.jpg",
              }}
              style={{
                borderRadius: 10,
                width: Dimensions.get("screen").width * 0.8,
                height: Dimensions.get("screen").width * 0.8,
                maxHeight: 500,
                maxWidth: 500,
              }}
            ></Image>
            <Text
              onPress={() => onDisableModal()}
              style={{ textDecorationLine: "underline", color: "white", alignSelf: "flex-end" }}
            >
              Dont show again
            </Text>
          </View>
        )}
      </Modal> */}

      {/* <Modal
        isVisible={showInstallPrompt || false}
        onBackdropPress={onCloseInstallPrompt}
        onBackButtonPress={onCloseInstallPrompt}
      >
        <View
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View
            style={{
              backgroundColor: "white",
              padding: 20,
              width: "100%",
              borderRadius: 20,
              alignItems: "center",
              maxWidth: 750,
            }}
          >
            <Ionicons name="add-circle-outline" size={50} color={companyTheme.first} />
            <Text
              style={{
                fontFamily: typography.primary.normal,
                fontSize: 18,
                marginVertical: 10,
                textAlign: "center",
              }}
            >
              Add to Home Screen
            </Text>
            <Text
              style={{
                fontFamily: typography.primary.normal,
                marginBottom: 20,
                textAlign: "center",
              }}
            >
              Install our app on your home screen for quick and easy access
            </Text>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-around",
                width: "100%",
                flexWrap: "wrap",
              }}
            >
              <Button
                title="Install"
                onPress={handleInstallClick}
                style={{ marginRight: 10, marginBottom: 10 }}
              />
              <Button
                style={{
                  backgroundColor: "transparent",
                  borderColor: companyTheme.first,
                  borderWidth: 1,
                }}
                titleStyle={{ color: companyTheme.first }}
                title="Not Now"
                onPress={onCloseInstallPrompt}
              />
            </View>
          </View>
        </View>
      </Modal> */}
    </Screen>
  )
})
